import { render, staticRenderFns } from "./dj-container.vue?vue&type=template&id=2a5deff0&scoped=true&"
import script from "./dj-container.vue?vue&type=script&lang=js&"
export * from "./dj-container.vue?vue&type=script&lang=js&"
import style0 from "./dj-container.vue?vue&type=style&index=0&id=2a5deff0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5deff0",
  null
  
)

export default component.exports